import React from 'react';

import { Tooltip } from '~/eds/src/components/Tooltip/Tooltip';

export const withTooltip =
  (WrappedComponent) =>
  ({ tooltip = null, ...restProps }) => (
    <Tooltip tooltip={tooltip}>
      <WrappedComponent {...restProps} />
    </Tooltip>
  );
